export function setText(el, data, attr, formatter) {
  const els = getElements(el, attr);
  const attrVal = (el) => el.getAttribute(`${attr}`); //If attribute has value use that as a key to the data map
  const value = (el) => attrVal(el) ? data?.[attrVal(el)] : data; // Else use data the value
  els.forEach((el) => {
      const val = value(el);
      el.textContent = formatter ? formatter(val, el) : val;
  });
}

export function toggleClass(el, data, attr, clazz, negate, cond) {
  const els = getElements(el, attr);
  const attrVal = (el) => el.getAttribute(`${attr}`); //If attribute has value use that as a key to the data map
  const value = (el) => attrVal(el) ? data?.[attrVal(el)] : data; // Else use data the value
  els.forEach((el) => {
      const val = value(el);
      toggle(el, val, clazz, negate, cond);
  });
}

export function setAttribute(el, data, searchAttr, valAttr) {
  const els = getElements(el, searchAttr);
  const attrVal = (el) => el.getAttribute(`${searchAttr}`); //If attribute has value use that as a key to the data map
  const value = (el) => attrVal(el) ? data?.[attrVal(el)] : data; // Else use data the value
  els.forEach((el) => {
      const val = value(el);
      el.setAttribute(valAttr, val);
  });
}

export function isNumeric(val) {
  return !isNaN(val);
}

function toggle(el, val, clazz, negate, cond) {
  if(el && clazz) {
    if(val != null && (!cond || cond(val))) {
      negate ? el.classList.add(clazz) : el.classList.remove(clazz);
    } else {
      negate ? el.classList.remove(clazz) : el.classList.add(clazz);
    }
  }
}

function getElements(el, attr) {
  return el.querySelectorAll(`[${attr}]`);
}
